import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify"
import { useGoogleLogin } from "@react-oauth/google"
import http from 'src/infrastructure/http'

const GoogleLoginPage = ({ onLoginComplete, onLoginFail, emailEnabled, onEmailLoginComplete }) => {
  const [loading, setLoading] = useState(false)
  const [emailLogin, setEmailLogin] = useState(false)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")

  const googleLogin = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      await login(codeResponse.code)
    },
    flow: "auth-code",
    scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/gmail.send'
  });

  const login = async (codeResponse) => {
    try {
      const token = await http.post('/v2/auth/login', { code: codeResponse })
      onLoginComplete(token.data.id_token)
      setLoading(false)
    } catch (e) {
      toast.error('Não foi possível realizar o login com sua conta google !')
      onLoginFail(e)
    }
  };

  return (
    <>
      {!emailLogin ? (
        <div>
          <button className="btn btn-primary btn-block" type="button" onClick={googleLogin}>
            {loading ? (
              <i className="fa fa-spin fa-spinner" />
            ) : (
              <>
                <i className="fa fa-google" />
                &nbsp;Shopper.com.br
              </>
            )}
          </button>
          {emailEnabled ? (
            <button
              className="btn btn-xs btn-block mt-2"
              type="button"
              onClick={() => setEmailLogin(true)}
            >
              Login com e-mail
            </button>
          ) : null}
        </div>
      ) : (
        <div>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="email@exemplo.com.br"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            className="btn btn-primary btn-block"
            type="button"
            onClick={() => onEmailLoginComplete(email, password)}
          >
            <i className="fa fa-mail" />
            &nbsp;Autenticar com e-mail
          </button>
          <button
            className="btn btn-xs btn-block mt-2"
            type="button"
            onClick={() => setEmailLogin(false)}
          >
            Login com Google
          </button>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default GoogleLoginPage;
